


















interface tabData {
    title: string,
    data: object[]
}


import ProductSpecificationTab from '@/components/v2/product-detail/ProductSpecificationTab.vue';
import Vue from 'vue';

export default Vue.extend({
    components: {ProductSpecificationTab},
    props: {
        tabs: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            currentTab: 0,
            tabData: []
        }
    },
    methods: {
        changeTab(index: number): void {
            this.currentTab = index;
        }
    },
    mounted() {
        this.tabData = JSON.parse(this.tabs);
    }
})
